import * as React from "react";
import { CommentsDialog } from "../misc/components/CommentsSelector";
import { SessionFixedCommentState, TestFixedCommentsState, ToggleAlertFixedCommentCheckedAction, ToggleAlertFixedCommentsVisibilityAction, ToggleSessionFixedCommentCheckedAction, ToggleSessionFixedCommentsVisibilityAction, ToggleTestFixedCommentCheckedAction, ToggleTestFixedCommentsVisibilityAction } from "./UseFixedComments";

export interface EcgCommentModalsProps {
    editable: boolean;
    testFixedComments: TestFixedCommentsState[];
    alertFixedComments: TestFixedCommentsState[];
    setIsPageValidated: (isValidated: boolean) => void
    isPageValid: boolean;
    dispatch: React.Dispatch<any>;
}

export const EcgCommentModals = ({ editable, testFixedComments, alertFixedComments, isPageValid, dispatch }: EcgCommentModalsProps) => {
    const renderInterpretationModals = () => {
        return (
            testFixedComments.map((tfc) => {
                return (
                    <CommentsDialog
                        key={`CommentsDialog${tfc.id}`}
                        editable={editable}
                        show={tfc.isVisible}
                        header={`Interpretations - Recording ${tfc.testNumber}`}
                        items={tfc.comments}
                        showFilter={true}
                        onChange={(id, checked) => dispatch(ToggleTestFixedCommentCheckedAction.create(tfc.id, id, checked))}
                        onClose={() => dispatch(ToggleTestFixedCommentsVisibilityAction.create(tfc.id))}
                    />
                );
            })
        );
    }

    const renderAlertModals = () => {
        return (
            alertFixedComments.map((tfc) => {
                return (
                    <CommentsDialog
                        key={`CommentsDialog${tfc.id}`}
                        editable={editable}
                        show={tfc.isVisible}
                        header={`Alerts - Recording ${tfc.testNumber}`}
                        items={tfc.comments}
                        showFilter={true}
                        onChange={(id, checked) => dispatch(ToggleAlertFixedCommentCheckedAction.create(tfc.id, id, checked))}
                        onClose={() => dispatch(ToggleAlertFixedCommentsVisibilityAction.create(tfc.id))}
                    />
                );
            })
        );
    }

    return (
        <>
            {renderInterpretationModals()}
            {renderAlertModals()}
        </>
    );
}
